"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var costate_1 = require("./costate");

exports.createCostate = costate_1.createCostate;
exports.getState = costate_1.getState;
exports.getCostate = costate_1.getCostate;
exports.isCostate = costate_1.isCostate;
exports.hasCostate = costate_1.hasCostate;
exports.co = costate_1.co;
exports.watch = costate_1.watch;
exports.remove = costate_1.remove;